export enum ProductStatusEnum {
  Purchased = 'purchased',
  On_Hold = 'on hold',
  Available = 'available',
  Bundled = 'bundled',
  Defective = 'defective',
  Loss = 'loss'
}

export enum FilterStockEnum {
  All = 'all',
  InStocks = 'in_stock',
  OutOfStocks = 'out_of_stock',
  HiddenFromPricelist = 'hidden_from_pricelist',
  HiddenFromQuotation = 'hidden_from_quotation'
}
